import React, { useState } from "react";
import { useTranslations } from "@jugl-web/utils";
import { FaqEntry } from "@web-src/modules/common/components/FaqEntry";

export const Faq = () => {
  const [openId, setOpenId] = useState<number | null>(1);
  const { t } = useTranslations();
  const FAQ_ITEMS = [
    {
      id: 1,
      question: t({
        id: "subscription-plans-dialog.faq.question-1",
        defaultMessage: "How do Jugl’s Billing Plans work?",
      }),
      answer: t({
        id: "subscription-plans-dialog.faq.answer-1",
        defaultMessage:
          "Jugl offers flexible Monthly and Yearly subscriptions, as well as optional Add-On packages to customize your workspace. Your features and usage limits are determined by the specific plan you select. To guarantee top-tier data protection and a seamless checkout experience, all payments are securely processed through our trusted partner, Stripe.",
      }),
    },
    {
      id: 2,
      question: t({
        id: "subscription-plans-dialog.faq.question-2",
        defaultMessage: "Does Jugl support an Autopay?",
      }),
      answer: t({
        id: "subscription-plans-dialog.faq.answer-2",
        defaultMessage:
          "Yes. For your convenience, subscriptions renew automatically. Your payment method on file will be charged on a monthly or annual basis, depending on the billing cycle you select at checkout.",
      }),
    },
    {
      id: 3,
      question: t({
        id: "subscription-plans-dialog.faq.question-3",
        defaultMessage: "Can I modify my Jugl subscription plan?",
      }),
      answer: t({
        id: "subscription-plans-dialog.faq.answer-3",
        defaultMessage:
          "Absolutely. You can upgrade, downgrade, or cancel your Jugl subscription at any time. Any applicable prorated charges or refunds will be automatically calculated based on your current plan and the exact date you make the change.",
      }),
    },
    {
      id: 4,
      question: t({
        id: "subscription-plans-dialog.faq.question-4",
        defaultMessage: "What is the length of the Jugl trial period?",
      }),
      answer: t({
        id: "subscription-plans-dialog.faq.answer-4",
        defaultMessage:
          "Instead of a limited-time trial, Jugl offers a completely Free plan that you can use indefinitely. Your free workspace will always remain accessible and includes 50 complimentary AI message credits every month.",
      }),
    },
    {
      id: 5,
      question: t({
        id: "subscription-plans-dialog.faq.question-5",
        defaultMessage: "Can I use Jugl services on multiple devices?",
      }),
      answer: t({
        id: "subscription-plans-dialog.faq.answer-5",
        defaultMessage:
          "Yes, you can access your account simultaneously across different platforms—for example, you can be logged into the mobile app and the web portal at the same time. However, to maintain account security, concurrent logins on the same device type (e.g., two mobile phones or two web browsers) using the same credentials are not permitted.",
      }),
    },
  ];
  return (
    <div className="flex w-full flex-col items-center px-10 pt-[220px] font-secondary">
      <div className="pb-12 text-center font-secondary text-[48px] leading-[72px] font-semibold text-black">
        Got questions? We have answers! 🙌
      </div>
      <div className="flex w-full max-w-[1000px] flex-col gap-2">
        {FAQ_ITEMS.map((item) => {
          const isOpen = openId === item.id;

          return (
            <FaqEntry
              key={item.id}
              question={item.question}
              answer={item.answer}
              isOpen={isOpen}
              onOpenSwitch={() =>
                setOpenId((prev) => (prev === item.id ? null : item.id))
              }
            />
          );
        })}
      </div>
    </div>
  );
};
